import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../svgIcon/SvgIcon';

export function LongArrow(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.91963 4.68469C10.0938 4.47037 10.4087 4.4378 10.623 4.61193L14.3153 7.61193C14.4322 7.70687 14.5 7.84942 14.5 7.99999C14.5 8.15055 14.4322 8.2931 14.3153 8.38804L10.623 11.388C10.4087 11.5622 10.0938 11.5296 9.91963 11.3153C9.7455 11.101 9.77808 10.7861 9.9924 10.6119L12.5917 8.49999H2C1.72386 8.49999 1.5 8.27613 1.5 7.99999C1.5 7.72384 1.72386 7.49999 2 7.49999H12.5917L9.9924 5.38804C9.77808 5.21391 9.7455 4.89901 9.91963 4.68469Z"
                fill={props.fill}
            />
        </SvgIcon>
    );
}

LongArrow.propTypes = {
    fill: PropTypes.string
};

LongArrow.defaultProps = {
    viewBox: '0 0 16 16',
    preserveAspectRatio: 'xMidYMid slice',
    fill: 'currentColor'
};

export default LongArrow;
